"use client";
import { AppShell, useDisclosure } from "@forestsync/ui";
import { Header } from "./Header";
import { NavBar } from "./NavBar";
import { VerifySpotlight } from "./VerifySpotlight";
import { memo, useMemo } from "react";

interface PlatformShellProps {
  children: React.ReactNode;
}

function PlatformShellComponent({ children }: PlatformShellProps) {
  const [opened, { toggle, close }] = useDisclosure();

  // Memoize navbar config to prevent unnecessary re-renders
  const navbarConfig = useMemo(
    () => ({
      width: 280,
      breakpoint: "sm" as const,
      collapsed: { desktop: true, mobile: !opened },
    }),
    [opened],
  );

  return (
    <AppShell header={{ height: 60 }} navbar={navbarConfig} padding={0}>
      <VerifySpotlight />
      {/* print:hidden — the registry's certificates are the page itself, printed. */}
      <AppShell.Header className="z-[1000] print:hidden">
        <Header opened={opened} toggle={toggle} close={close} />
      </AppShell.Header>

      <AppShell.Navbar p="md" className="print:hidden">
        <NavBar close={close} />
      </AppShell.Navbar>

      <AppShell.Main className="h-[calc(100vh-60px)] overflow-auto print:h-auto print:overflow-visible print:!p-0">
        {children}
      </AppShell.Main>
    </AppShell>
  );
}

export const PlatformShell = memo(PlatformShellComponent);
